import type { Job } from '@mairistem/composants';
import type { Bordereau } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type DuplicatePayload from '../../../interfaces/pieces/DuplicatePayload';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';

export const createBordereau = (
	bordereau: Partial<Bordereau> | BordereauWithState,
) => {
	const url = '/api/finances/comptabilite/piecescomptables/bordereaux/';
	return request.post<Partial<Bordereau>, Bordereau>(url, bordereau);
};

export const updateBordereau = (
	bordereau: Partial<Bordereau>,
	params?: URLSearchParams,
) => {
	const url = '/api/finances/comptabilite/piecescomptables/bordereaux/';
	const query = params ? `?${params.toString()}` : '';
	return request.put<Partial<Bordereau>, Bordereau>(
		`${url}${bordereau.identifiant}${query}`,
		bordereau,
	);
};

export const dupliquerBordereau = (
	bordereau: Partial<Bordereau>,
	shouldReprendreReferences: boolean,
	dateEcheance?: string,
	dateDepartDelaiGlobalPaiement?: string,
	datePrelevement?: string,
	dateRealisationPrestationDebut?: string,
	dateRealisationPrestationFin?: string,
) => {
	const parameters: DuplicatePayload = {
		shouldReprendreReferences,
		dateEcheance,
		dateDepartDelaiGlobalPaiement,
		datePrelevement,
		dateRealisationPrestationDebut,
		dateRealisationPrestationFin,
	};

	const url = `/api/finances/comptabilite/piecescomptables/bordereaux/${bordereau.identifiant}/dupliquer`;
	return request.post<DuplicatePayload, Job>(url, parameters);
};

export const getBordereau = (identifiantBordereau: number) => {
	const url = '/api/finances/comptabilite/piecescomptables/bordereaux/';
	return request.get<unknown, Bordereau>(`${url}${identifiantBordereau}`);
};

export const getBordereaux = (params: URLSearchParams) => {
	const url = '/api/finances/comptabilite/piecescomptables/bordereaux?';
	return request.get<unknown, TemplateRequestGet<Bordereau>>(
		`${url}${params.toString()}`,
	);
};

export const deleteBordereau = (identifiantBordereau: number) => {
	const url = '/api/finances/comptabilite/piecescomptables/bordereaux/';
	return request.delete<unknown, unknown>(`${url}${identifiantBordereau}`);
};

export const updateBordereauEtat = (
	identifiantBordereau: number,
	params?: URLSearchParams,
) => {
	const url = `/api/finances/comptabilite/piecescomptables/bordereaux/${identifiantBordereau}/majStatusDossier`;
	const query = params ? `?${params.toString()}` : '';
	return request.get<unknown, Bordereau>(`${url}${query}`);
};

export const rejeterBordereau = (identifiantBordereau: number) => {
	const url = `/api/finances/comptabilite/piecescomptables/bordereaux/${identifiantBordereau}/rejeter`;
	return request.post<DuplicatePayload, Job>(url);
};
